import React, { useEffect, useState } from 'react';
import { CameraIcon, CheckIcon, DownloadIcon, MessageCircleIcon } from 'lucide-react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
type Target = 'stories' | 'whatsapp' | 'save';

/**
 * Reusable share destination sheet. Sharing is always a user action;
 * the prototype stops at "image ready" — the OS share sheet is REQUIRES DEVICE.
 */
export function ShareSheet({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const {
    t
  } = useLocale();
  const [done, setDone] = useState<Target | null>(null);
  useEffect(() => {
    if (!open) setDone(null);
  }, [open]);
  const targets: {
    id: Target;
    label: string;
    Icon: typeof CameraIcon;
  }[] = [{
    id: 'stories',
    label: t('eng.share.stories'),
    Icon: CameraIcon
  }, {
    id: 'whatsapp',
    label: t('eng.share.whatsapp'),
    Icon: MessageCircleIcon
  }, {
    id: 'save',
    label: t('eng.share.save'),
    Icon: DownloadIcon
  }];
  const chosen = targets.find(target => target.id === done);
  return <Modal open={open} onClose={onClose} labelledBy="share-sheet-title" data-id="element-605" data-mp="151elcickdy57">
      <h2 id="share-sheet-title" className="pr-5 text-section text-deep" data-id="element-606" data-mp="19yn3iixpq26g">
        {done ? t('eng.share.ready') : t('eng.share.sheet')}
      </h2>
      {chosen ? <div className="mt-2" data-id="element-607" data-mp="1jwkrr6fknyz2">
          <p className="flex items-start gap-2 text-[13px] leading-relaxed text-muted" data-id="element-608" data-mp="1jxvvj690p6q6">
            <CheckIcon size={16} className="mt-[2px] shrink-0 text-gold-deep" aria-hidden="true" data-id="element-609" data-mp="1nx4q2dbvt8ms" />
            {t('eng.share.readyBody', {
          target: chosen.label
        })}
          </p>
          <Button variant="primary" size="lg" fullWidth className="mt-3" onClick={onClose} data-id="element-610" data-mp="1xnfus23e3luq">
            {t('common.close')}
          </Button>
        </div> : <>
          <p className="mt-1 text-[12px] text-muted" data-id="element-611" data-mp="27m5dty70vcck">{t('eng.share.format')}</p>
          <ul className="mt-2 space-y-1" data-id="element-612" data-mp="27k2get3jigxt">
            {targets.map(({
          id,
          label,
          Icon
        }) => <li key={id} data-id="element-613" data-mp="2bl4cj125ucvk">
                <button type="button" onClick={() => setDone(id)} className="flex min-h-[52px] w-full items-center gap-2 rounded-card border border-sand-line bg-white/70 px-2 text-left transition-colors duration-150 ease-brand hover:border-deep/25" data-id="element-614" data-mp="ci7dak6gzibb">
                  <span className="grid h-9 w-9 place-items-center rounded-[10px] bg-sand-deep text-deep" data-id="element-615" data-mp="gj9bcxonhobp">
                    <Icon size={17} aria-hidden="true" data-id="element-616" data-mp="v7x8v9i2484a" />
                  </span>
                  <span className="text-[13.5px] font-medium text-deep" data-id="element-617" data-mp="q92ct5v2wn28">{label}</span>
                </button>
              </li>)}
          </ul>
        </>}
    </Modal>;
}